import { createClient } from '@supabase/supabase-js';

/** Filled at build time (local dev) or via setRuntimeSupabaseConfig (Cloud Run). */
let runtimeUrl = '';
let runtimeAnonKey = '';

let client = null;

function readEnv() {
  const fromBuild = {
    url: process.env.REACT_APP_SUPABASE_URL?.trim() ?? '',
    anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY?.trim() ?? '',
  };
  if (fromBuild.url && fromBuild.anonKey) return fromBuild;
  return { url: runtimeUrl, anonKey: runtimeAnonKey };
}

export function setRuntimeSupabaseConfig(url, anonKey) {
  runtimeUrl = url?.trim() ?? '';
  runtimeAnonKey = anonKey?.trim() ?? '';
  client = null;
}

/** True when the SPA can talk to Supabase (build-time or runtime config). */
export function isSupabaseConfigured() {
  const { url, anonKey } = readEnv();
  return Boolean(url && anonKey);
}

/**
 * Load Supabase settings from the API when REACT_APP_* were not inlined at build (e.g. Cloud Run).
 * @returns {Promise<boolean>}
 */
export async function loadSupabaseConfigFromApi() {
  const base = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');
  const res = await fetch(`${base}/config`);
  if (!res.ok) return false;
  const data = await res.json();
  if (!data.supabaseUrl || !data.supabaseAnonKey) return false;
  setRuntimeSupabaseConfig(data.supabaseUrl, data.supabaseAnonKey);
  return true;
}

/**
 * Returns the browser Supabase client, or null if URL / anon key are missing.
 * Never call createClient with empty strings — @supabase/supabase-js throws.
 */
export function getSupabase() {
  if (!isSupabaseConfigured()) return null;
  if (!client) {
    const { url, anonKey } = readEnv();
    client = createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  }
  return client;
}
